"use strict";

exports.__esModule = true;
exports.MetricValueBatchContext = exports.EMPTY_METRIC_VALUE_BATCH = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Shared historic metric values for the devices in a table or grid.
 * `undefined` from getValue means this device, metric, and interval are not in the batch.
 */
var EMPTY_METRIC_VALUE_BATCH = exports.EMPTY_METRIC_VALUE_BATCH = {
  isCovered: function isCovered() {
    return false;
  },
  isLoading: function isLoading() {
    return false;
  },
  getValue: function getValue() {
    return undefined;
  }
};
var MetricValueBatchContext = exports.MetricValueBatchContext = /*#__PURE__*/_react["default"].createContext(EMPTY_METRIC_VALUE_BATCH);